<template>
    <div>
        <el-dialog
            :visible.sync="permissionModalOpen"
            :append-to-body="true"
        >
            <div>

                <el-radio v-model="level" label="manager">{{ getVerbose('user_action_radio_option_manager') }}</el-radio>
                <el-radio v-model="level" label="simpleuser">{{ getVerbose('user_action_radio_option_simpleuser') }}</el-radio>
                <el-radio v-model="level" label="admin">{{ getVerbose('user_action_radio_option_admin') }}</el-radio>
                <el-radio v-model="level" label="blocked">{{ getVerbose('user_action_radio_option_blocked') }}</el-radio>

                <el-button type="primary" @click="sendSelection">{{ getVerbose('user_action_radio_button') }}</el-button>
            </div>
        </el-dialog>
        <el-dropdown
            class="more-user-actions"
            @command="handleMoreActions"
        >
            <span class="el-dropdown-link">
                <i class="ti-more"/>
            </span>
            <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item
                    command="edit-user">
                    Edit user
                </el-dropdown-item> -->
                <el-dropdown-item command="chg-pswd">{{ getVerbose('user_action_change_password') }}</el-dropdown-item>
                <el-dropdown-item
                    command="update-permission">
                    {{ getVerbose('user_action_upgrade_permission') }}
                </el-dropdown-item>
                <!-- <el-dropdown-item
                    command="remove-user">
                    Remove user
                </el-dropdown-item> -->
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>

import {mapGetters} from 'vuex';
export default {

    components: {

    },

    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    data: function(){
        return {
            level: '',
            permissionModalOpen: false,
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ])
    },

    mounted: function(){

    },

    methods: {
        // méthode non utilisée
        canEditUser() {
            return this.$store.getters.userIsAtLeastManager && this.$store.getters.canEditUser;
        },

        canRemoveUser (){
            let userLevel = this.user.level.toLowerCase();
            if(userLevel === 'admin' || userLevel === 'blocked'){
                return false;
            }else if(this.$store.getters.userIsAtLeastAdmin){
                return true;
            }else if(this.$store.getters.userIsAtLeastManager && userLevel === 'simpleuser'){
                return true;
            }
            return false;
        },

        handleMoreActions(command){
            if(command === 'chg-pswd'){
                this.promptForPassword();
            }
            else if(command === 'update-permission'){
                this.promptForUserLevel();
            }
            else if(command === 'remove-user'){
                // TODO this.removeFromProject(command.user);
            } else if (command === 'edit-user') {
                // En attente
            }
        },

        promptForUserLevel (){
            this.permissionModalOpen = true;

            // comprend pas pk ça marche pas

            // const h = this.$createElement;
            // this.$msgbox({
            //     title: 'Select a level permission',
            //     message: h('div', null, [
            //        h(PermissionModal),
            //    ]),
            //     showCancelButton: true,
            //     confirmButtonText: 'OK',
            //     closeOnClickModal: true,
            // });
        },
        sendSelection (){
            this.$store.dispatch('patchItem', {
                item: {
                    uid: this.user.uid,
                    url: this.user.url,
                    level: this.level,
                },
                model: 'users',
            }).then(() => {
                this.$notify.success({
                    title: this.getVerbose('user_action_upgrade_permission_success_title'),
                    message: `${this.getVerbose('user_action_upgrade_permission_success_message_beginning')} ${this.level} ${this.getVerbose('user_action_upgrade_permission_success_message_end')} ${this.user.verbose_name}`
                });
            }, error=>{
                console.error(error);
                this.$notify.error({
                    title: this.getVerbose('user_action_upgrade_permission_failure_title'),
                    message: `${this.getVerbose('user_action_upgrade_permission_failure_message_beginning')} ${this.level} ${this.getVerbose('user_action_upgrade_permission_failure_message_end')} ${this.user.verbose_name}`
                });
            });
        },

        // TODO En attente de voir comment le scope d'entité fonctionnera

        removeFromProject (){
            let projectUid = null; //??????????????????????????.uid;
            let userEntities = this.user[this.entityModelKey];
            let index = userEntities.indexOf(projectUid);
            if(index === -1) return;
            userEntities.splice(index,1);
            let item = {};
            item[this.entityModelKey] = userEntities;
            item.url = this.user.url;
            this.$store.dispatch('patchItem', {
                model: 'users',
                item: item
            }).then(() => {
                this.$notify.success({
                    title: this.getVerbose('user_action_remove_user_success'),
                });
            }, error => {
                console.error(error);
                this.$notify.error({
                    title: this.getVerbose('user_action_remove_user_failure'),
                });
            });
        },

        promptForPassword(){
            this.$prompt('Please input a new password', 'Change password', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                inputPattern: /.{5,}/,
                inputErrorMessage: 'Password too short'
            }).then(value => {
                this.$store.axios.patch(`${this.$store.getters.apiRootUrl}/auth/change-password/`, {
                    uid: this.user.uid,
                    password: value.value,
                }).then(() => {
                    this.$notify.success({
                        title: this.getVerbose('user_action_change_password_success_title'),
                        message: `${this.getVerbose('user_action_change_password_success_message')} ${this.user.verbose_name}`
                    });
                }).catch((error) => {
                    console.error(error);
                    this.$notify.error({
                        title: this.getVerbose('user_action_change_password_failure_title'),
                        message: `${this.getVerbose('user_action_change_password_failure_message')} ${this.user.verbose_name}`
                    });
                });
            }).catch(() => {
            });
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/usersManagement/user/user-action.vue